import { fromJS } from 'immutable';
import axios from 'axios';
import _ from 'lodash';
import { toCamelCase } from 'utils/immutable';

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = window.g_csrfCookieName;

const API_VERSION = 'v1';

export const INITIAL_STATE = fromJS({
    detail: {
        id: null,
        slug: null,
        metaFields: []
    },
    list: [],
    layers: {}
});

/* actions */
export const actionTypes = {
    UPDATE_SURVEY_DEFINITION: 'UPDATE_SURVEY_DEFINITION'
};

const updateSurveyDefinition = surveyDefinition => ({
    type: actionTypes.UPDATE_SURVEY_DEFINITION,
    surveyDefinition
});

export const actions = {
    updateSurveyDefinition
};

export const ACTIONS = {
    ADD_LAYERS: 'ADD_LAYERS',
    UPDATE_LAYERS: 'UPDATE_LAYERS',
    DELETE_LAYERS: 'DELETE_LAYERS',
    LIST_RESPONSES: 'LIST_RESPONSES',
    CREATE_RESPONSE: 'CREATE_RESPONSE',
    DELETE_ALL_LAYERS: 'DELETE_ALL_LAYERS',
    DELETE_RESPONSE: 'DELETE_RESPONSE'
};

export function deleteAllLayers() {
    return {
        type: ACTIONS.DELETE_ALL_LAYERS
    }
}

export function listResponses(responses){
    return {
        type: ACTIONS.LIST_RESPONSES,
        responses
    };
}

export function fetchResponses(startLoading = false) {
    return (dispatch) => {
        if (startLoading) {
            dispatch(updateLoadingState(startLoading));
        }

        return axios
            .get(window.Util.reverseURL('api_dispatch_list', API_VERSION, 'survey-response-list'))
            .then(resp => dispatch(listResponses(resp.data.objects)));
    };
}

export function createResponse(data) {
        return axios
            .post(window.Util.reverseURL('api_survey_response_create', API_VERSION, data.survey), data)
            .then(function (response) {
                return response
            })
            .catch(function (error) {
                if (_.get(error, 'response.status') === 400) {
                    throw error;
                }
                throw error;
            });
}

export function editResponse(id, data) {
    return axios
        .patch(window.Util.reverseURL('api_dispatch_detail', API_VERSION, 'survey-responses', id), data)
        .then(function (response) {})
        .catch(function (error) {
            if (_.get(error, 'response.status') === 400) {
                throw error;
            }
            throw error;
        });
}

export function getResponse(id) {
    return axios
        .get(window.Util.reverseURL('api_dispatch_detail', API_VERSION, 'survey-responses', id))
        .catch(function (error) {
            if (_.get(error, 'response.status') === 400) {
                throw error;
            }
            throw error;
        });
}

export function addLayers(layers) {
    return {
        type: ACTIONS.ADD_LAYERS,
        layers
    };
}

export function updateLayers(layers) {
    return {
        type: ACTIONS.UPDATE_LAYERS,
        layers
    };
}

export function deleteLayers(layers) {
    return {
        type: ACTIONS.DELETE_LAYERS,
        layers
    };
}

export function deleteResponse(id) {
    return {
        type: ACTIONS.DELETE_RESPONSE,
        id
    }
}


/* reducer */
export const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ACTIONS.ADD_LAYERS:
        case ACTIONS.UPDATE_LAYERS:
            return state.update(
                'layers',
                layers => layers.mergeWith((oldValue, newValue) => oldValue.merge(newValue), fromJS(action.layers))
            );
        case ACTIONS.DELETE_LAYERS:
            let newState = state
            action.layers.forEach(layer => {
                newState = newState.update('layers', layers => layers.removeIn([layer]));
            })
            return newState
        case ACTIONS.DELETE_ALL_LAYERS:
            return state.merge({layers: {}})
        case actionTypes.UPDATE_SURVEY_DEFINITION:
            return state.mergeIn(['detail'], fromJS(action.surveyDefinition).mapEntries(toCamelCase));
        case ACTIONS.LIST_RESPONSES:
            return state.mergeIn(['list'], action.responses);
        case ACTIONS.DELETE_RESPONSE:
            const stateJS = state.toJS()
            const index = stateJS.list.indexOf(stateJS.list.find(layer => layer.id === action.id))
            return state.removeIn(['list', index])
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./source/modules/surveys.js